export default "__VITE_ASSET__3655c59e__"